import componentRoutes from './components';
import authRoutes from './auth';

export default [
    ...componentRoutes,
    ...authRoutes
];